import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=4a727ccc&"
import script from "./CustomerForm.vue?vue&type=script&lang=ts&"
export * from "./CustomerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports